import { Draft } from 'immer';
import { produce } from "immer";
import { Funcion } from "@/types";
import { EventoStore } from "./evento";

export interface FuncionSlice {
    state: Funcion | null;
    set: (funcion: Funcion | null) => void;
    clear: () => void;
}

export const createFuncionSlice = (set: any): FuncionSlice => ({
    state: null,
    set: (funcion) => set(produce((state: Draft<EventoStore>) => { state.funcion.state = funcion; })),
    clear: () => set(produce((state: Draft<EventoStore>) => { state.funcion.state = null; })),
});

